module.exports = __webpack_public_path__ + "static/media/circular-std-medium.eot";